import { asMoney, formatRailsTimestamp } from 'lib/utilities'
import domecileMapImage from '/app/assets/images/domecile_map_request.png'

import React, { useState } from 'react'

export default function PaymentFlowSideBar(props) {
  const { propertyAddress, unitId, building_address, status, questionnaireRequest, subTotal, fee, total } = props

  const [showTooltip, setShowTooltip] = useState(false)

  const handleMouseOver = () => setShowTooltip(true)
  const handleMouseOut = () => setShowTooltip(false)

  return (
    <>
      <div className="dome-d-flex dome-flex-column dome-gap18">
        <div>
          <span className="dome-h4 dome-color-lite-grey">
            request #{questionnaireRequest.property_manager_id}-{questionnaireRequest.confirmation_id}
          </span>
        </div>
        <div className="dome-d-flex dome-align-center dome-gap12">
          <img width={113} height={78} style={{ borderRadius: '6px' }} src={domecileMapImage} />
          <div
            style={{ overflowWrap: 'anywhere' }}
            className="dome-d-flex dome-flex-column dome-align-start dome-justify-center"
          >
            <span className="dome-p2 dome-color-dark-grey">{propertyAddress}</span>
            <span className="dome-p2 dome-color-dark-grey">{unitId}</span>
            <span className="dome-p2 dome-color-dark-grey">
              {building_address.city}, {building_address.state}, {building_address.zip}
            </span>
          </div>
        </div>
      </div>
      <div style={{ margin: '18px 0px', height: 1, background: '#DBDBDB' }}></div>
      <div className="dome-d-flex dome-flex-column dome-full-width dome-gap12">
        <span className="dome-h3 dome-color-dark-grey">checkout total</span>
        <div className="dome-d-flex dome-flex-column dome-gap6">
          <div className="dome-d-flex dome-justify-between dome-align-center">
            <span className="dome-p1 dome-color-dark-grey">sub total:</span>
            <span className="dome-p1 dome-color-dark-grey">{asMoney(subTotal)}</span>
          </div>
          <div className="dome-d-flex dome-justify-between dome-align-center">
            <div className="dome-d-flex dome-gap3 dome-align-center dome-relative">
              <span className="dome-p1 dome-color-dark-grey">app admin fee:</span>
              <i
                onMouseOut={handleMouseOut}
                onMouseOver={handleMouseOver}
                className="fa-thin fa-xs fa-circle-question dome-color-dark-grey"
              ></i>
              {showTooltip && (
                <div
                  style={{
                    right: 0,
                    bottom: 0,
                    width: 220,
                    borderRadius: 6,
                    position: 'absolute',
                    padding: '6px 12px',
                    background: '#F9F9F9',
                    transform: 'translateY(100%)',
                    boxShadow: '0px 3px 6px 0px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <span className="dome-p3 dome-color-darkest-grey dome-text-w300">
                    This charge is for the costs related to facilitating this digital transaction.
                  </span>
                </div>
              )}
            </div>
            <span className="dome-p1 dome-color-dark-grey">{asMoney(fee)}</span>
          </div>
        </div>
      </div>
      <div style={{ margin: '12px 0px', height: 1, background: '#DBDBDB' }}></div>
      <div className="dome-d-flex dome-flex-column dome-gap6">
        <div className="dome-d-flex dome-justify-between dome-align-center">
          <span className="dome-p1 dome-text-w500 dome-color-dark-grey">total: </span>
          <span className="dome-p1 dome-color-dark-grey">{asMoney(total)}</span>
        </div>
        <div className="dome-d-flex dome-justify-between dome-align-center">
          <span className="dome-p1 dome-text-w500 dome-color-dark-grey">status:</span>
          <span className="dome-p1 dome-color-dark-grey">{status}</span>
        </div>
      </div>
    </>
  )
}
